import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const cochesnetTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.cochesnet,
  logoUrl: "https://cdn.nemuru.com/assets/logos/cochesnet.svg",
  palette: {
    primary: {
      main: "#00031c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ed2134",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#b2bec8",
      contrastText: "#000",
      accent: "#ed2134",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#00031c",
      primary: "#00031c",
      secondary: "#3d4a5b",
    },
    status: {
      sent: "#525252",
      denied: "#ed2134",
    },
    info: {
      main: "#242F44",
      contrastText: "#ffffff",
      light: "#d6dbdf",
    },
    warning: {
      main: "#d87b26",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#057e4b",
      contrastText: "#ffffff",
      light: "rgba(0,125,174,0.15)",
    },
    grey: {
      50: "#fafafa",
      100: "#eef0f5",
      200: "#dce0e3",
      300: "#d4dbe1",
      400: "#bcc8d2",
      500: "#98a4b7",
      600: "#778598",
      700: "#424e5e",
      800: "#3b4356",
      900: "#00031c",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#e6ebf1",
  customBorderRadius: {
    button: 40,
    paper: 4,
  },
  typography: {
    // fontFamily: "'Montserrat', sans-serif",
    fontFamily: "'Open Sans', sans-serif",
  },
};
